import React, { memo } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-185">
      <div className="max-w-3xl mx-auto" data-id="element-186">
        <div ref={fadeIn.ref} className={`space-y-8 text-lg md:text-xl ${fadeIn.className}`} data-id="element-187">
          <div className="text-center mb-12" data-id="element-188">
            <h2 className="text-3xl md:text-4xl font-black text-yellow-400 mb-6" data-id="element-189">
              💔 Mientras tratás de conectar con tu familia… el tiempo se te
              escapa
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-190">
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-191">
              <div className="text-4xl mb-4" data-id="element-192">🕒</div>
              <p className="text-gray-300 font-medium" data-id="element-193">
                Pasan los días y sentís que apenas compartís momentos reales con
                tus hijos.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-194">
              <div className="text-4xl mb-4" data-id="element-195">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-196">
                Todo se vuelve pantallas, trabajo y cansancio… y las charlas se
                hacen cada vez más cortas.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-197">
              <div className="text-4xl mb-4" data-id="element-198">💤</div>
              <p className="text-gray-300 font-medium" data-id="element-199">
                Aunque amás a tu familia, muchas noches terminás con la
                sensación de que no estás aprovechando el tiempo juntos.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-200">
              <div className="text-4xl mb-4" data-id="element-201">⚠️</div>
              <p className="text-gray-300 font-medium" data-id="element-202">
                Si no cambiás algo ahora, los días seguirán pasando sin esos
                recuerdos que tanto soñás crear.
              </p>
            </div>
          </div>

          <div className="text-center mt-12 space-y-4" data-id="element-203">
            <p className="text-2xl font-bold text-white" data-id="element-204">
              No es falta de amor ni de ganas ❤️
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-205">
              Es que no tenés el método correcto para reconectar.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-4" data-id="element-206">
              No es falta de ganas, es que la rutina te roba el tiempo. Sin una
              guía que te motive a crear recuerdos reales, 💭 seguís dejando los
              momentos importantes "para después"… y después nunca es hoy.
            </p>
          </div>

          <div className="bg-gray-900 p-8 rounded-xl border border-yellow-500 mt-12 shadow-2xl" data-id="element-207">
            <div className="space-y-6 text-gray-300" data-id="element-208">
              <p className="flex items-start gap-3" data-id="element-209">
                <span className="text-2xl" data-id="element-210">🔑</span>
                <span className="font-bold text-white" data-id="element-211">
                  Lo que necesitás es una herramienta que te devuelva el tiempo,
                  te inspire y te ayude a crear recuerdos sin esfuerzo.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-212">
                <span className="text-2xl" data-id="element-213">📔</span>
                <span data-id="element-214">
                  Con las "100 Citas Familiares" vas a tener ideas listas para
                  cada día, sin planificar nada.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-215">
                <span className="text-2xl" data-id="element-216">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-217">
                  Solo elegís una cita, la compartís y disfrutás. Más conexión,
                  más risas, más momentos inolvidables 💞
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}